/** Build-time configuration. Only public values reach the browser. */
export const env = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL as string,
  supabaseKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string,
  appVersion: (import.meta.env.VITE_APP_VERSION as string | undefined) ?? 'dev',
  appName: 'didto. OS',
  sentryDsn: (import.meta.env.VITE_SENTRY_DSN as string | undefined) ?? '',
};

export function assertEnv(): void {
  if (!env.supabaseUrl || !env.supabaseKey) {
    throw new Error(
      'Missing VITE_SUPABASE_URL / VITE_SUPABASE_PUBLISHABLE_KEY. Copy apps/staff/.env.example to .env.local.',
    );
  }
}
